import { Text } from '@tectonic/elemason-components';
import { useThemeContext } from '@tectonic/uikit';
import { addSeconds, format, formatDistance } from 'date-fns';
import { useHaloScript } from '../../hooks/useHaloScript';

import type { ElemasonDateWidget } from '@tectonic/types';
import type { Color } from '@tectonic/uikit';
import type { FC } from 'react';

interface ElemasonDateWidgetProps {
  widget: ElemasonDateWidget;
}

const DateWidget: FC<ElemasonDateWidgetProps> = ({
  widget: { data, config },
}) => {
  const { colors } = useThemeContext();
  const text = useHaloScript(data?.text);
  const dateStr = useHaloScript(data?.date) ?? 'now';
  const formatStr = useHaloScript(config?.format) ?? '';
  const offsetSeconds = useHaloScript(data?.offsetSeconds) ?? 0;
  const placeholders = useHaloScript<Record<string, string>>(
    data?.placeholders
  );

  let date;

  switch (config?.mode) {
    case 'distance':
      date = formatDistance(
        addSeconds(
          dateStr === 'now' ? new Date() : new Date(dateStr),
          parseInt(`${offsetSeconds}`, 10) ?? 0
        ),
        Date.now()
      );
      break;
    default:
      date = format(
        addSeconds(
          dateStr === 'now' ? new Date() : new Date(dateStr),
          parseInt(`${offsetSeconds}`, 10) ?? 0
        ),
        formatStr
      );
  }

  return (
    <Text
      data={text}
      config={{
        ...config?.text,
        color: colors[config?.text?.color as Color] ?? config?.text?.color,
      }}
      placeholders={{ ...placeholders, date }}
    />
  );
};

export { DateWidget };
